import React from 'react'

export default function FloatIcon({classN = ""}) {
  const new_class = (classN != "") ? classN : "";
  return (
    <div className={`cic-icon-fly ${new_class}`}>
        <img 
            src="https://assets-us-01.kc-usercontent.com/4f626d0e-ea43-0058-7ee6-030359e555db/027fd9b9-0307-4d91-aaca-b4d84a7554a9/paper-plane.svg"
        />
    </div>
  )
}
